<template>
<el-drawer title="设置底价" :visible.sync="visible" :wrapperClosable="false" size="35%">
    <div class="draw-form">
        <el-form ref="form" :model="form" label-width="80px" label-position="top">
            <el-form-item v-for="(item, index) in prices" :key="index" :label="getPriceTitle(item)">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
        </el-form>
    </div>
</el-drawer>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            prices: [],
            form: {}
        };
    },
    methods: {
        showDrawer(category_id) {
            this.visible = true;
            this.category_id = category_id;
            this.visible = true;
            // 获取类型的规则
            let _this = this;
            let url = '/api/supplier.category/min';
            let params = {
                id: category_id
            };
            this.$post(url, params).then(res => {
                _this.prices = res.data.prices;
            })

        },
        getPriceTitle(item) {
            let title = [];
            item.forEach(ele => {
                let arr = ele.split(":");
                title.push(arr[2]);
            });

            return title.join('/');
        }
    }
}
</script>
